'use client';

import { usePathname } from 'next/navigation';
import { useEffect, JSX } from 'react';

import { pageView } from '../lib/GTM/events';

export default function Analytics(): JSX.Element | null {
    const pathname = usePathname();

    useEffect(() => {
        pageView(pathname);
    }, [pathname]);

    return null;
}
